// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LocationAddressCorrectionModel {
    static getAttributeTypeMap() {
        return LocationAddressCorrectionModel.attributeTypeMap;
    }
}
LocationAddressCorrectionModel.discriminator = undefined;
LocationAddressCorrectionModel.additionalProperties = false;
LocationAddressCorrectionModel.attributeTypeMap = [
    {
        "name": "correction",
        "baseName": "correction",
        "type": "LocationCorrection"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
];
//# sourceMappingURL=locationAddressCorrectionModel.js.map